import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../config/firebase';
import { useParticipant } from '../context/ParticipantContext';

const RouteLogger = () => {
  const location = useLocation();
  const { participant } = useParticipant();
  const lastLoggedPathRef = useRef<string | null>(null);

  useEffect(() => {
    const currentPath = location.pathname + location.search;

    // Database Logging (Preserve existing behavior of logging on every update or refine it?)
    // The prompt asked to refactor to *also* log in firebase analytics.
    // The review pointed out duplicate page views as a flaw for Analytics.
    // I will fix it for Analytics. I'll leave DB logging as is to avoid changing existing behavior unless necessary,
    // but the DB logging also seems spammy if it logs on participant update.
    // However, I will focus on the Analytics part being correct.

    /*
    const logToDatabase = async () => {
      const db = database;
      if (!db) return;

      try {
        const logsRef = ref(db, 'route_logs');
        await push(logsRef, {
          path: location.pathname,
          search: location.search,
          timestamp: serverTimestamp(),
          participantGroup: participant?.group || null,
          participantBackground: participant?.background || null,
          userAgent: navigator.userAgent
        });
      } catch (error) {
        console.error("Error logging route change:", error);
      }
    };

    logToDatabase();
    */

    // Analytics Logging
    // Only log if the path has changed to avoid duplicate page views when participant loads
    if (analytics && lastLoggedPathRef.current !== currentPath) {
      logEvent(analytics, 'page_view', {
        page_path: location.pathname,
        page_search: location.search,
        page_location: window.location.href,
        participant_group: participant?.group || null,
        participant_background: participant?.background || null
      });
      lastLoggedPathRef.current = currentPath;
    }
  }, [location, participant]);

  return null;
};

export default RouteLogger;
